<template>
  <!-- 性价比解读弹窗-->
  <Cost-Performance-Popup
    v-if="costPerformanceExplain && Object.keys(costPerformanceExplain).length"
    ref="cost"
    v-zpm="{ sectionid: 131, sortname: '性价比解读' }"
    class="goods-container_costperformance"
    :costPerformanceExplainProps="{ ...costPerformanceExplain, tagList }"
    :infoId="computedInfoId"
    :orderId="orderId"
    platform="zz"
    :isAutoReceiveRedPacket="
      state.joinCalRealPriceRedPlans && state.joinCalRealPriceRedPlans.length ? true : false
    "
    :showButton="state.packageId ? false : true"
    @clickBuy="$emit('costPerformanceBuy')"
  >
    <div class="cost-wrapper">
      <div class="cost-wrapper__header">
        <span class="title">性价比解读</span>
        <div class="tag-list-wrap">
          <span v-for="(item, index) in tagList" :key="index" :class="itemClass(item.type || 2)">{{
            item.tagName
          }}</span>
        </div>
      </div>
      <div
        v-zpm="{ sortname: '性价比解读唤起弹窗', sortid: 0 }"
        class="cost-wrapper__bottom"
        @click="$refs.cost.costPerfHandle()"
      >
        <span class="introduce">{{ appendContent }}</span>
        <span class="view">查看</span>
      </div>
    </div>
  </Cost-Performance-Popup>
</template>

<script>
import { state } from '@/store'
import { computed, defineComponent } from '@vue/composition-api'
import CostPerformancePopup from '@zz-yp/b2c-ui/src/cost-performance-popup/index'
import '@zz-yp/b2c-ui/lib/cost-performance-popup/style.css'
export default defineComponent({
  components: {
    CostPerformancePopup
  },
  props: {
    costPerformanceExplain: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const classMap = new Map([
      [0, ''],
      [1, 'tag-list-same'],
      [2, 'tag-list-grey'],
      [3, 'tag-list-grey-line']
    ])
    const computedInfoId = computed(() => {
      return state.infoId
    })
    const orderId = computed(() => {
      return state.orderId
    })
    const appendContent = computed(() => {
      // premiumTipContent 劝退文案
      // handPricePremiumContent 溢价文案
      return (
        props.costPerformanceExplain?.premiumTipContent ||
        props.costPerformanceExplain?.handPricePremiumContent ||
        props.costPerformanceExplain.appendContent
      )
    })

    const tagList = computed(() => {
      return props?.costPerformanceExplain?.tagList || []
    })

    const itemClass = (type) => {
      return ['tag-list-item', classMap.get(type) || '']
    }
    return {
      computedInfoId,
      orderId,
      appendContent,
      tagList,
      itemClass,
      state
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

.cost-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 32px;
  margin-top: 20px;
  margin-bottom: 68px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 24px;
  border-bottom-right-radius: 48px;
  &__header {
    display: flex;
    margin-top: 9px;
    margin-bottom: 10px;
    font-family: PingFangSC-Semibold, PingFang SC;
    .title {
      margin: 5px 16px 0 0;
      color: #111;
      font-weight: 600;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 26px;
      white-space: nowrap;
    }
    .tag-list-wrap {
      flex: 1;
      height: 37px;
      overflow: hidden;
      font-size: 0;
    }
    .tag-list-item {
      display: inline-block;
      box-sizing: border-box;
      margin-right: 8px;
      margin-bottom: 5px;
      padding: 8px 12px;
      color: #111;
      font-weight: 300;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 20px;
      white-space: nowrap;
      border-radius: 8px;
    }
    .tag-list-same {
      background: linear-gradient(166deg, #f7ddff 0%, #ddfeff 100%);
    }
    .tag-list-grey {
      background: #efefef;
    }
    .tag-list-grey-line {
      @include border-1px(#cbcbcb, 8px);
      color: #111;
    }
  }
  &__bottom {
    margin-bottom: 6px;
    color: #111111;
    font-weight: 300;
    font-size: 22px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 34px;
    .view {
      position: relative;
      top: -3px;
      margin-left: 11px;
      font-size: 18px;
      line-height: 18px;
      &::after {
        @include hairline(#111111);
        border-bottom-width: 1px;
      }
    }
  }
}
</style>
